module.exports = __webpack_public_path__ + "static/media/MoveToProdExample.486f2ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/Licenses/MoveToProdExample.png
// module id = 1077
// module chunks = 0